import React, { useState } from 'react';
import { PiCheckCircleFill } from "react-icons/pi";
import { MdOutlinePersonalVideo } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import { message, Modal } from 'antd';
import { useSnapshot } from 'valtio';
import { CustomTemplateStore } from '@/utils/store/customTemplate';

interface TemplateCardUDProps {
  id?: string;
  title: string;
  info: string;
  userId: string;
  value: string;
  curKey: string;
  sk: (value: string) => void;
}

const TemplateCardUD: React.FC<TemplateCardUDProps> = ({ 
  id,
  title, 
  info, 
  userId, 
  value, 
  curKey, 
  sk 
}) => {
  const isSelect = value === curKey;
  const { deleteLoading } = useSnapshot(CustomTemplateStore);
  const [infoModalVisible, setInfoModalVisible] = useState(false);
  
  // 截断描述文本，最多显示40个字符
  const truncatedInfo = info.length > 28 ? `${info.substring(0, 28)}...` : info;

  // 展开详细信息
  const handleExpand = (e: React.MouseEvent) => {
    e.stopPropagation(); // 阻止事件冒泡
    setInfoModalVisible(true);
  };

  // 删除模板函数
  const handleDelete = async (e: React.MouseEvent) => {
    e.stopPropagation(); // 阻止事件冒泡
    
    if (!id) {
      message.error('模板ID不存在');
      return;
    }

    Modal.confirm({
      title: '确认删除',
      content: `确认要删除模板“${title}”吗？此操作不可撤销。`,
      okText: '确认删除',
      cancelText: '取消',
      okType: 'danger',
      onOk: async () => {
        const success = await CustomTemplateStore.deleteTemplate(id, userId);
        if (success) {
          message.success('模板删除成功');
          // 如果当前选中的模板被删除，清除选中状态
          if (isSelect) {
            sk('');
          }
        }
      }
    });
  };

  return (
    <div 
      className={`card bg-[#F6F7FC] rounded-3xl w-56 shadow-sm mt-1 ${isSelect ? "shadow-2xl" : ""}
        transition duration-150 ease-in-out hover:-translate-y-0.5 hover:scale-102 hover:shadow-xl
        relative font-inter cursor-pointer
      `}
      onClick={() => sk(value)}
    >
      <div className="card-body p-4">
        <div className="flex items-center  relative">
          <MdOutlinePersonalVideo 
            className="w-8 h-8 bg-[#242630] rounded-full p-2 text-white"
          />
          <div className="ml-2 bg-blue-100 text-blue-600 text-xs px-2 py-1 rounded-full">
            自定义
          </div>
          
          <div className="ml-auto flex items-center gap-1">
            {/* 删除按钮 */}
            <button
              onClick={handleDelete}
              disabled={deleteLoading}
              className="p-1 rounded-full hover:bg-red-100 text-gray-400 hover:text-red-500 transition-colors duration-200"
              title="删除模板"
            >
              <RiDeleteBin6Line className="w-4 h-4" />
            </button>
          </div>
        </div>
        
        <div className="text-[16px] text-[#242630] " title={title}>
          {title.length > 12 ? `${title.substring(0, 12)}...` : title}
        </div>
        
        <div className="text-[11px] text-[#242630] mt-[-8px] opacity-60 mb-3" title={info}>
          {truncatedInfo}
        </div>
      </div>
      
      {/* 展开按钮 - 始终显示在右下角 */}
      <div className="absolute bottom-3 right-3">
        <button
          onClick={handleExpand}
          className="flex items-center gap-1 px-2 py-1 bg-white/80 hover:bg-white rounded-full shadow-sm hover:shadow-md transition-all duration-200 text-xs text-gray-600 hover:text-blue-600 border border-gray-200 hover:border-blue-300"
          title="展开详细信息"
        >
          <span className='text-[10px]'>展开</span>
          {/* <AiOutlineUp className="w-3 h-3" /> */}
        </button>
      </div>
      
      {/* 选中状态指示器 - 调整位置避免与展开按钮重叠 */}
      {isSelect && (
        <div className="absolute bottom-[-4px] right-[-4px] rounded-full">
          <PiCheckCircleFill className="text-2xl text-[#4B5563]" />
        </div>
      )}
      
      {/* 信息展示模态框 */}
      <Modal
        title={`模板详细信息 - ${title}`}
        open={infoModalVisible}
        onCancel={() => setInfoModalVisible(false)}
        footer={[
          <button
            key="close"
            onClick={() => setInfoModalVisible(false)}
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors duration-200"
          >
            关闭
          </button>
        ]}
        width={600}
      >
        <div className="py-4">
          <div className="text-gray-700 whitespace-pre-wrap leading-relaxed">
            {info || '暂无详细信息'}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default TemplateCardUD;